module.exports = __webpack_public_path__ + "images/emoji/heavy_dollar_sign.9aef7a327deaf6de3bc5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heavy_dollar_sign.png
// module id = dDwX
// module chunks = 13